/** The registration step's tool keys and radial menu. */
import { useToolHotkeys } from '~/components/toolbar/shared/useToolHotkeys';
import { useViewingToolEntries } from '~/components/toolbar/shared/useViewingToolEntries';
import { useRegistrationModeEntries } from '~/components/toolbar/tools/RegistrationModeTool/useRegistrationModeEntries';
import RadialToolMenu from '~/components/toolbar/radialMenu/RadialToolMenu';

interface RegistrationToolShortcutsProps {
    isDisabled: boolean;
    disabledReason?: string;
    /** Runs after a registration mode is armed, as the toolbar's mode buttons do. */
}

export default function RegistrationToolShortcuts({
    isDisabled,
    disabledReason,
}: RegistrationToolShortcutsProps) {
    const { translation, rotation } = useRegistrationModeEntries(
        isDisabled,
        disabledReason
    );
    const { pan, boxZoom, rotateView, measurement } = useViewingToolEntries();
    // Clockwise from the top: the two image moves side by side, pan at the
    // bottom.
    const menu = [translation, rotation, measurement, pan, rotateView, boxZoom];
    useToolHotkeys(menu);
    return <RadialToolMenu entries={menu} />;
}
